import '../types/externs'
import askQuestions, { askSingle, confirm } from './'

module.exports = {
  '_askSingle': askSingle,
  '_confirm': confirm,
  '_askQuestions': askQuestions,
}